/* @jsx h */
import { defineComponent, h } from "vue";
import { RouterLink, useRoute } from "vue-router";
import { cn } from "@lemmonhq/uikit";

export const ManagerTablesSidebar = defineComponent({
  name: "ManagerTablesSidebar",
  setup() {
    const route = useRoute();

    const getLinkClass = (isActive?: boolean) => {
      return cn(
        "border-b  flex justify-between items-start cursor-pointer flex flex-col p-4 border-l-4 ",
        isActive ? "border-l-blue-500 bg-gray-800" : "border-l-transparent",
      );
    };

    return () => (
      <div class="w-64 border-r  py-0 font-headline">
        <h2 class="text-2xl text-accent  border-b  px-2 py-4 mb-0 component">
          <span class="flex justify-start items-center">
            <span class="material-symbols-outlined mr-1 text-2xl border rounded  mr-3 w-8 h-8 flex items-center justify-center">
              table_restaurant
            </span>
            <span>Tables</span>
          </span>
        </h2>
        <div class="">
          <RouterLink
            to="/app/manager/tables"
            class={getLinkClass(!route.query.filter)}
          >
            <div class="flex-1 flex flex-col">
              <div class="text-accent truncate text-ellipsis flex items-center">
                <span class="material-symbols-outlined mr-2 text-2xl">
                  calendar_month
                </span>
                All
              </div>
            </div>
          </RouterLink>
          <RouterLink
            to="/app/manager/tables?filter=available"
            class={getLinkClass(route.query.filter == "available")}
          >
            <div class="flex-1 flex flex-col">
              <div class="text-accent truncate text-ellipsis flex items-center">
                <span class="material-symbols-outlined mr-2 text-2xl">
                  event_available
                </span>
                Available
              </div>
            </div>
          </RouterLink>
          <RouterLink
            to="/app/manager/tables?filter=busy"
            class={getLinkClass(route.query.filter == "busy")}
          >
            <div class="flex-1 flex flex-col">
              <div class="text-accent truncate text-ellipsis flex items-center">
                <span class="material-symbols-outlined mr-2 text-2xl">
                  event_busy
                </span>
                Busy
              </div>
            </div>
          </RouterLink>
        </div>
      </div>
    );
  },
});
